var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"vld-parent"},[_c('loading',{attrs:{"active":_vm.isLoading,"can-cancel":false,"is-full-page":true,"z-index":10000000,"background-color":"#000","color":"#fff"},on:{"update:active":function($event){_vm.isLoading=$event}}})],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }